export default class LabelComponent {
  that = null;
  auto_width = false;
  auto_height = false;
  offset = {
    top: 0,
    left: 0,
  };
  rendered = false;

  constructor(arg) {
    this.that = arg;
  }

  emitSize() {
    this.that.$emit("resize", {
      width:
        this.that.$refs.element.offsetWidth +
        this.that.$refs.element.offsetLeft,
      height:
        this.that.$refs.element.offsetHeight +
        this.that.$refs.element.offsetTop,
      parent: this.that.$parent.$parent,
    });
  }

  getStyle(style, offset_override = null) {
    this.auto_width =
      this.that.src.Width == null || this.that.src.Width == "auto";
    this.auto_height =
      this.that.src.Height == null || this.that.src.Height == "auto";

    Object.assign(this.that.$refs.element.style, style);

    Object.assign(
      this.offset,
      offset_override != null
        ? offset_override
        : {
            top: this.that.$refs.element.offsetTop + this.that.parentOffset.top,
            left:
              this.that.$refs.element.offsetLeft + this.that.parentOffset.left,
          }
    );

    this.emitSize();
  }

  resize(size) {
    if (size.parent.label.auto_width) {
      const width = size.parent.$refs.element.offsetWidth;
      size.parent.$refs.element.style.width =
        Math.max(width, size.width) + "px";
    }
    if (size.parent.label.auto_height) {
      const height = size.parent.$refs.element.offsetHeight;
      size.parent.$refs.element.style.height =
        Math.max(height, size.height) + "px";
    }

    size.parent.label.emitSize();
  }
}
